import { FC } from 'react';

import { TrackType } from '@/constants';
import { useTrackersStore } from '@/shared';

import { Tracker } from './components';

export const HistoryTrackers: FC = () => {
  const { trackers } = useTrackersStore();

  return trackers
    .filter((el) => el && el.unique && el.type !== TrackType.SWAP)
    .map((tracker) => <Tracker tracker={tracker} key={tracker.unique} />);
};
